<template>
  <div data-testid="deal-rating">
    <div
      v-if="deal.is_free"
      class="appsumo-freebie-counter-container"
    >
      <FreebieCounter :deal="deal" />
    </div>
    <div
      v-else
      class="appsumo-taco-rating-container"
    >
      <TacoRating
        :deal="deal"
        :is-deal-card="isDealCard"
        :condensed="condensed"
      />
    </div>
  </div>
</template>

<script>
import FreebieCounter from './FreebieCounter.vue';
import TacoRating from './TacoRating.vue';

export default {
  name: 'DealRating',
  components: {
    FreebieCounter,
    TacoRating,
  },
  props: {
    deal: {
      type: Object,
      required: true,
    },
    isDealCard: {
      type: Boolean,
    },
    condensed: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
  .appsumo-taco-rating-container {
    --taco-height: 24px;
    --taco-width: 120px;
  }
</style>
